module.exports = __webpack_public_path__ + "assets/img/youtube_768.89e827ee.png";